// 仅浏览器端使用，避免在构建/SSR 时加载 @cloudcare/browser-rum（会访问 navigator）
// @ts-expect-error package.json 没有类型声明
import pkg from "../../package.json";

let rumInstance: { addAction: (type: string, data: any) => void } | null = null;

export default function datafluxRumInit() {
  if (typeof window === "undefined") return;
  import("@cloudcare/browser-rum").then(({ datafluxRum }) => {
    datafluxRum.init({
      applicationId: "fe_h5_app_nextjs",
      site: "https://us1-openway.guance.com",
      clientToken: "669b007067264af5a2e090e5cce75105",
      env: process.env.NEXT_PUBLIC_ENV === "production" ? "prod" : "common",
      version: (pkg as { version?: string }).version || "0.0.0",
      service: "browser",
      sessionSampleRate: 3,
      compressIntakeRequests: true,
      trackInteractions: true,
      // @ts-expect-error traceType 类型定义不完整
      traceType: "ddtrace",
      remoteConfiguration: true,
      allowedTracingOrigins: [
        /https:\/\/h5-api.buscari\.[a-z0-9.-]+\.[a-z0-9-]+(?::\d+)?/i,
        /https:\/\/ai-api.buscari\.[a-z0-9.-]+\.[a-z0-9-]+(?::\d+)?/i,
      ],
      // NEXT_PUBLIC_BASE_URL=https://h5-api.buscari.com
      // NEXT_PUBLIC_BASE_URL_STREAM=https://ai-api.buscari.com
    });
    rumInstance = datafluxRum;
  });
}

export function reportError(type: string, data: any) {
  if (typeof window !== "undefined" && rumInstance) {
    rumInstance.addAction(type, data);
  }
}
